<template>
  <page>
    <div>
      <form>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field
                          v-model="filters.curr"
                          :label="labels.curr"
                          :error-messages="errors.collect('curr')"
                          data-vv-name="curr"
                          :data-vv-as="labels.curr"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field
                          v-model="filters.currDesc"
                          :label="labels.currDesc"
                          :error-messages="errors.collect('currDesc')"
                          data-vv-name="busCls"
                          :data-vv-as="labels.currDesc"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <cal-picker
                          :label="labels.effDateFrom"
                          v-model="filters.effDateFrom"
                          :error-messages="errors.collect('effDateFrom')"
                          data-vv-name="effDateFrom"
                          :max="filters.effDateTo"
                          :data-vv-as="labels.effDateFrom"
                        ></cal-picker>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <cal-picker
                          :label="labels.effDateTo"
                          v-model="filters.effDateTo"
                          :error-messages="errors.collect('effDateTo')"
                          data-vv-name="effDateTo"
                          :min="filters.effDateFrom"
                          :data-vv-as="labels.effDateTo"
                        ></cal-picker>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <div>
            <v-layout row wrap>
              <v-btn color="primary" dark class=" mr-2" @click="doNewCurr"> New Currency <v-icon right>mdi-plus</v-icon> </v-btn>
              <form ref="CSVForm">
                <input type="file" style="display: none" ref="CSVfile" accept=".csv" @change="doValidateFile" />
              </form>
              <v-btn color="primary" @click="pickFile"> Upload Rate <v-icon right>mdi-upload</v-icon> </v-btn>
              <download-csv :data="currencyItems" name="CurrencyList.csv">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-2" fab dark small color="primary" v-on="on">
                      <v-icon dark>mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <span>Download CSV</span>
                </v-tooltip>
              </download-csv>
            </v-layout>
          </div>
        </v-card-title>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="items"
            :server-items-length="totalItems"
            v-bind:options.sync="pagination"
            :loading="loading"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            :no-data-text="noDataText"
          >
            <template v-slot:item="row"
              ><tr>
                <td class="text-xs-left">{{ row.item.curr }}</td>
                <td class="text-xs-left">{{ row.item.currDesc }}</td>
                <td class="text-xs-left">{{ row.item.rate }}</td>
                <td class="text-xs-left">{{ formatDisplayDate(row.item.effDate) }}</td>
                <td class="table-action-header">
                  <table-action
                    :rowData="row"
                    query
                    @query="doQuery(row.item.curr, row.item.effDate)"
                    review
                    @review="doCurrReview(row.item.curr, row.item.effDate)"
                    remove
                    @remove="doPromptRemove"
                  ></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-card>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">Please confirm deletion of this record.</confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import parse from 'date-fns/parse'
import { displayDateFormat, formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import { Validator } from 'vee-validate'
import { csvObj } from '@/utils/file'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'
import isAfter from 'date-fns/isAfter'

export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Currency Code', align: 'left', value: 'curr' },
        { text: 'Description', value: 'currDesc' },
        { text: 'Exchange Rate', value: 'rate' },
        { text: 'Effective Date', value: 'effDate' },
        TableConst.tableActionHeader
      ],
      labels: {
        curr: 'Currency Code',
        currDesc: 'Description',
        effDateFrom: 'Effective From',
        effDateTo: ' Effective To'
      },
      filters: {
        curr: null,
        currDesc: null,
        effDateFrom: null,
        effDateTo: null
      },
      totalItems: 0,
      selectedCurr: undefined,
      newCurr: false,
      loading: false,
      uploading: false,
      promptRemove: false,
      tranMode: null,
      pagination: {
        sortDesc: [false],
        page: 1
      },
      currencyItems: []
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  computed: {
    currMenu() {
      return this.$store.state.currParam.menu
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doInit(options) {
      await this.getAll()
      this.resetMessages()
      const apiURI = this.currMenu.getCurrencyPage
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let currFilters = clone(this.filters)
          if (currFilters.effDateFrom) {
            currFilters.effDateFrom = formatDisplayDateTime2(removeTime(currFilters.effDateFrom))
          }
          if (currFilters.effDateTo) {
            currFilters.effDateTo = formatDisplayDateTime2(removeTime(currFilters.effDateTo))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), currFilters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((curr) => {
                const convertList = {
                  curr: curr.curr,
                  currDesc: curr.currDesc,
                  rate: curr.rate,
                  effDate: curr.effDate
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    async getAll() {
      const apiURI = this.currMenu.getCurrencyAllList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        this.currencyItems = []
        if (data) {
          data.map((curr) => {
            const convertList = {
              curr: curr.curr,
              currDesc: curr.currDesc,
              rate: curr.rate,
              effDate: curr.effDate
            }
            this.currencyItems.push(convertList)
          })
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.curr = null
      this.filters.currDesc = null
      this.filters.effDateFrom = null
      this.filters.effDateTo = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.pagination.page = 1
      this.doInit(false)
    },
    async doCurrReview(curr, effDate) {
      this.$router.push({ name: 'currencyReview', params: { curr: curr, effDate: formatDisplayDate(effDate), tranMode: 'Review' } })
    },
    doNewCurr() {
      this.$router.push({ name: 'currencyReview', params: { curr: 'new', effDate: 'new', tranMode: 'New' } })
    },
    async doPromptRemove(record) {
      this.resetMessages()
      // this.selectedCurr = data.item
      // this.promptRemove = true
      if (record) {
        if (isAfter(removeTime(record.item.effDate), removeTime(new Date()))) {
          try {
            const apiURI = this.currMenu.checkDeleteCurrency
            const expand = {
              curr: record.item.curr
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.selectedCurr = record.item
              this.promptRemove = true
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.fieldMessage(data)
              this.message(data)
              // this.notify(data)
            }
          }
        } else {
          this.selectedCurr = record.item
          this.promptRemove = true
        }
      }
    },
    async doRemove() {
      const apiURI = this.currMenu.deleteCurrency
      if (apiURI) {
        const expand = this.selectedCurr
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(false)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    pickFile() {
      this.$refs.CSVForm.reset()
      this.$refs.CSVfile.click()
    },
    async getFile(event) {
      this.file = event.target.files[0]
    },
    doValidateFile(e) {
      this.resetMessages()
      if (e.target.files[0]) {
        this.uploading = true
        const file = e.target.files[0]
        if (file.name.indexOf('.csv') !== -1) {
          const fileReader = new FileReader()
          fileReader.onload = async () => {
            if (fileReader.result.substring(0, 8) !== 'Currency') {
              this.errorMessage('This is not a currency excel sheet.')
            } else {
              const result = csvObj(fileReader.result)
              let allValid = true
              if (result && result.length > 0) {
                const validator = new Validator()
                for (let i = 0; i < result.length; i++) {
                  const row = result[i]
                  let noCol = 3
                  let rowValid = true
                  let errorMsg = null
                  if (noCol === row.length) {
                    for (let x = 0; x < row.length; x++) {
                      let col = row[x].trim()
                      try {
                        switch (x) {
                          case 0:
                            const currValidation = await validator.verify(col, 'required|name|max:4')
                            if (!currValidation.valid) {
                              rowValid = false
                              errorMsg = currValidation.errors[0].replace('{field}', 'Currency')
                            }
                            break
                          case 1:
                            const rateValidation = await validator.verify(col, 'required|mask_max_value:9999999.999999')
                            if (!rateValidation.valid) {
                              rowValid = false
                              errorMsg = rateValidation.errors[0].replace('{field}', 'Exchange Rate')
                            }
                            break
                          case 2:
                            const convertDate = parse(col, displayDateFormat, new Date())
                            const effDateValidation = await validator.verify(convertDate, 'required|checkEffDate|checkFormat')
                            if (!effDateValidation.valid) {
                              rowValid = false
                              errorMsg = effDateValidation.errors[0].replace('{field}', 'Effective Date')
                            }
                            break
                        }
                      } catch (err) {
                        rowValid = false
                        errorMsg = 'Row Exception Error. Please check input fields.'
                      }
                    }
                  } else {
                    rowValid = false
                    errorMsg = 'Invalid Column No.'
                  }
                  if (!rowValid) {
                    this.errorMessage('Row ' + (i + 2) + ': ' + errorMsg)
                    allValid = false
                  }
                }
              }
              if (allValid) {
                this.doUpload(e)
              }
            }
          }
          fileReader.readAsText(file)
          this.uploading = false
        }
      }
    },
    async doUpload(event) {
      await this.getFile(event)
      const apiURI = this.currMenu.currUpload
      if (apiURI) {
        try {
          let formData = new FormData()
          formData.append('file', this.file, this.file.name)
          const result = await this.$http.post(apiURI, formData)
          if (result) {
            this.notify(result.data)
          } else {
            this.errorMessage('fail to Upload')
          }
        } catch (err) {
          const result = err.response
          const { data } = result.data
          if (data) {
            this.fieldMessage(data)
            this.message(data)
            this.fetchData(false)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doQuery(curr, effDate) {
      this.$router.push({ name: 'currencyReview', params: { curr: curr, effDate: formatDisplayDate(effDate), tranMode: 'Query' } })
    }
  },
  created() {
    const checkEffDate = {
      getMessage: (field, args) => {
        return 'The ' + field + ' cannot earlier than today'
      },
      validate: (value, args) => {
        var today = new Date().setHours(0, 0, 0, 0)
        return !(value < today)
      }
    }
    this.$validator.extend('checkEffDate', checkEffDate)

    const checkFormat = {
      getMessage: (field, args) => {
        return 'Invalid date format. Plase enter the effective date with dd/MM/yyyy format'
      },
      validate: (value, args) => {
        value = value.toString()
        return value !== 'Invalid Date'
      }
    }
    this.$validator.extend('checkFormat', checkFormat)
  },
  mounted() {
    this.doInit(true)
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
